// extracted by mini-css-extract-plugin
export var body = "_md-8";
export var button = "_md-0";
export var closeButton = "_md-5";
export var content = "_md-3";
export var empty = "_md-f";
export var grid = "_md-c";
export var header = "_md-4";
export var icon = "_md-1";
export var option = "_md-d";
export var optionSelected = "_md-e";
export var overlay = "_md-2";
export var searchIcon = "_md-a";
export var searchInput = "_md-b";
export var searchWrapper = "_md-9";
export var title = "_md-6";
export var visuallyHidden = "_md-7";